import { isPlaceholderResult } from '#pplx/frontend/stream/utils.js';
export const getLastBackendUUID = (forceNew, fork, isFirstEntry, articleOverride, lastResultBackendUUID) => {
    // Special case for rewriting first entry.
    if (isFirstEntry && !articleOverride) {
        return undefined;
    }
    if (forceNew && !fork) {
        return undefined;
    }
    if (articleOverride) {
        return articleOverride.backend_uuid;
    }
    // A failed optimistic placeholder is the only entry after a first request
    // dies; it has no backend entry to continue from, so the resubmit is a fresh ask.
    if (lastResultBackendUUID && isPlaceholderResult(lastResultBackendUUID)) {
        return undefined;
    }
    return lastResultBackendUUID;
};
//# sourceMappingURL=getLastBackendUUID.js.map